<template>
  <div>
    <organism-idc-customer-management
      v-if="filterData"
      :filter-list="filterData"
      :customer-name-option="customerNameOption"
      :business-type-option="businessTypeOption"
      :fields="fields"
      :items="customerList"
      @clickRow="clickRow"
      @onUpdateFilterData="onUpdateFilterData"
      @onUpdateCurrentPageOrPerPage="onUpdateCurrentPageOrPerPage"
      @onSetDefaultFilterData="onSetDefaultFilterData"
    ></organism-idc-customer-management>
  </div>
</template>

<script>
import OrganismIdcCustomerManagement from "@/components/organisms/portal/internal/OrganismIdcCustomerManagement.vue"
import mixins from "@/mixins"
import {
  getCustomerList,
  getBusinessTypeList,
  getCustomerNameList,
} from "@/api/api-module1"
import { mapActions, mapGetters } from "vuex"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "IdcManagement",
  components: { OrganismIdcCustomerManagement },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      customerNameOption: [],
      businessTypeOption: [],
      fields: [
        {
          key: "customer",
          label: "CUSTOMER NAME",
          thClass: "w-200px",
          tdClass: "w-200px",
        },
        {
          key: "organizationName",
          label: "Organization Name",
          thClass: "w-200px",
          tdClass: "w-200px",
        },
        {
          key: "businessType",
          label: "Business Type",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
        {
          key: "address",
          label: "ADDRESS",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
        {
          key: "contact",
          label: "CONTACT",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
      ],
      customerList: [],
      filterData: null,
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getInternalIdcCustomerFilter"]),
  },
  async mounted() {
    await this.getBusinessTypeListFromApi()
    await this.getCustomerListFromApi()
    await this.getCustomerNameListFromApi()
  },
  methods: {
    ...mapActions("appFilter", ["setInternalIdcCustomerFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getInternalIdcCustomerFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    async getBusinessTypeListFromApi() {
      this.showLoading(true)
      await getBusinessTypeList()
        .then((response) => {
          if (response) {
            this.businessTypeOption = response.data
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getCustomerNameListFromApi() {
      this.showLoading(true)
      await getCustomerNameList()
        .then((response) => {
          if (response) {
            this.customerNameOption = response
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getCustomerListFromApi() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const filterData = this.filterDecoration()
      await getCustomerList(filterData)
        .then((response) => {
          this.filterData.totalCount = response.data.pagination.total
          const updatedFilter = {
            ...this.getInternalIdcCustomerFilter,
            totalCount: response.data.pagination.total,
          }
          this.setInternalIdcCustomerFilter(updatedFilter)
          this.customerList = response.data.data.map((customer) => {
            return {
              id: customer.customerId,
              customer: customer.customerName,
              organizationName: customer.mainAddress.organizationName,
              businessType: this.getBusinessTypeNameById(
                customer.mainAddress.businessTypeId
              ),
              address: this.getFullAddressDetail(customer.mainAddress),
              contact: {
                email: customer.mainAddress.email,
                phone: customer.mainAddress.phone,
                fax: customer.mainAddress.fax,
              },
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    filterDecoration() {
      const filter = {
        PageSize: this.filterData.perPage,
        PageNumber: this.filterData.currentPage,
        CustomerName: this.filterData.customer?.customerName || undefined,
        OrganizationName: this.filterData.organizationName || undefined,
        BusinessTypes: this.filterData.businessType.length
          ? this.filterData.businessType.map((item) => item.businessTypeId)
          : undefined,
      }
      return filter
    },

    // click filter
    onUpdateFilterData(filter) {
      filter.currentPage = 1
      this.setInternalIdcCustomerFilter(filter)
      this.getCustomerListFromApi()
    },

    onUpdateCurrentPageOrPerPage(filter) {
      const updatedFilter = {
        ...this.getInternalIdcCustomerFilter,
        currentPage: filter.currentPage,
        perPage: filter.perPage,
      }
      this.setInternalIdcCustomerFilter(updatedFilter)
      this.getCustomerListFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        customer: "",
        businessType: [],
        organizationName: "",
        currentPage: 1,
        totalCount: 0,
        perPage: 10,
      }
      this.setInternalIdcCustomerFilter(defaultFilter)
      this.getCustomerListFromApi()
    },

    getBusinessTypeNameById(businessTypeId) {
      return this.businessTypeOption.find(
        (option) => option.businessTypeId === businessTypeId
      )?.businessTypeName
    },

    getFullAddressDetail(addressData) {
      return [
        addressData.address,
        addressData.subDistrict,
        addressData.district,
        addressData.province,
        addressData.country === "Thailand" ? "ประเทศไทย" : addressData.country,
        addressData.postalCode,
      ].join(" ")
    },

    clickRow(record, index) {
      this.$router.push("/internal/web-portal/idc/customer/" + record.id)
    },
  },
}
</script>

<style lang="scss" scoped></style>
